import { render, staticRenderFns } from "./checkInRecords.vue?vue&type=template&id=63bfdaa0&scoped=true"
import script from "./checkInRecords.vue?vue&type=script&lang=js"
export * from "./checkInRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bfdaa0",
  null
  
)

export default component.exports